import MobileLayout from './SortableListViewLayout.mobile';
import WebLayout from './SortableListViewLayout.web';
import { isReactNative } from 'ui-builder';

export default isReactNative() ? MobileLayout : WebLayout;
